import {AxiosInstance, AxiosResponse} from "axios";
import {Contract} from "@/core/interfaces/Contract";

/** The `contract_statuses` row of an accepted contract. */
const CONTRACT_STATUS_ACCEPTED = 1;

/**
 * API resource for contract.
 *
 * @param client
 */
export const ContractResource = (client: AxiosInstance) => {
    return {
        /**
         * Get the accepted contract.
         */
        async readAccepted(): Promise<Contract[]> {
            const params = {
                include: "version",
                wrappers: {response: null}
            };

            return client.get("/contracts/accepted", {params})
                .then((response: AxiosResponse) => response.data.contracts);
        },
        /**
         * Get the contract index.
         */
        async index(): Promise<Contract[]> {
            const params = {
                include: "version",
                wrappers: {response: null}
            };

            return client.get("/contracts", {params})
                .then((response: AxiosResponse) => response.data.contracts);
        },
        /**
         * Get a contract, with its current version.
         *
         * @param slug The contract slug.
         */
        async read(slug: string): Promise<Contract> {
            const params = {
                include: "version",
                wrappers: {response: null}
            };

            return client.get(`/contracts/${slug}`, {params})
                .then((response: AxiosResponse) => response.data.contract);
        },
        /**
         * Record that the organization accepts a contract version, under the
         * user signed in. The API keeps the first acceptance of each version.
         *
         * @param versionId The contract version id.
         */
        async accept(versionId: number): Promise<void> {
            await client.post(
                `/contracts/versions/${versionId}/validations`,
                {status_id: CONTRACT_STATUS_ACCEPTED},
                {params: {wrappers: {response: null}}}
            );
        }
    };
};

export default ContractResource;
